import React from 'react';
import type {BoxProps} from '@tempo/core';
import {HStack, Text} from '@tempo/core';
import {ArrowTopIcon, ArrowBottomIcon} from '@tempo/icons';

type RankProgressProps = {
	progress: number | string;
} & BoxProps;

const RankProgress = ({progress = 0, ...rest}: RankProgressProps) => {
	const isEqual = Number(progress) === 0;
	const isIncreasing = Number(progress) > 0 || progress === 'NEW';

	let color = 'text.neutral.secondary.default'; // TODO we don't have a neutral feedback
	if (isIncreasing) {
		color = 'text.feedback.success.default';
	} else if (Number(progress) < 0) {
		color = 'text.feedback.error.default';
	}

	return (
		<HStack
			color={color}
			mt={2}
			mb={4}
			justifyContent="center"
			spacing={0}
			{...rest}
		>
			{!isEqual ? (
				isIncreasing ? (
					<ArrowTopIcon boxSize="icon.s" />
				) : (
					<ArrowBottomIcon boxSize="icon.s" />
				)
			) : (
				<Text variant="body.small.strong">=</Text>
			)}
			{!isEqual && (
				<Text
					variant="body.small.regular"
					color="text.neutral.secondary.default"
				>
					{`${Number(progress) > 0 ? '+' : ''}${progress}`}
				</Text>
			)}
		</HStack>
	);
};

export default RankProgress;
